import logo from './img/Palnau-olde-1-w.png';
import './App.css';
import './Content.css';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Family from './routes/Family';
import About from './routes/About';
import Portal from './routes/Portal';
import EmailInstructions from './routes/EmailInstructions';

function App() {
  const location = useLocation();
  return (
    
    <div className="App">
      <header className="App-header" style={location.pathname === '/' ? { justifyContent: 'center' } : { justifyContent: 'normal' }}>
        <Link to="/"><img src={logo} className="App-logo" alt="logo" /></Link>
        <nav className="App-nav">
          <Link className="App-link" to="/family">Family</Link>
          <Link className="App-link" to="/portal">Portal</Link>
          <Link className="App-link" to="/about">About</Link>
        </nav>
        <div className="App-content">
          <Routes>
            <Route path="/family" element={<Family />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/about" element={<About />} />
            <Route path="/email-instructions" element={<EmailInstructions />} />
          </Routes>
        </div>
      </header>
    </div>
  );
}

export default App;
